import React from "react";
import ModalHeader from "@/customComponents/uiComponents/modal/ModalHeader.jsx";
import CompleteProfileForm from "@/customComponents/uiComponents/global/CompleteProfileForm.jsx";
import {queryClient} from "@/lib/queryClient";
import {storage, STORAGE_KEYS} from "@/utils/storage";

/**
 * "Your profile is incomplete" — collects whatever the booking gate still wants.
 *
 * The backend refuses POST /trips with `422 identity_incomplete` until the account has a
 * real name, email AND phone. Reached from orderDetails / mainPolicies Continue, BEFORE
 * payment (see utils/identityGate `bookingIdentityStep`). The missing list and onward step
 * come through storage — steps share one fixed prop shape.
 *
 * One screen, CompleteProfileForm: Google / Apple link the name + a verified email to the
 * account in one tap (while a name or email is missing); otherwise the name goes through the
 * account update and a VERIFIED email / phone through add → code → verify → set default.
 * `/complete-identity` is no longer called — it stored contacts unverified. No terms line:
 * the order page already carries the agreement.
 */
export function CompleteProfile({setStep, closeModal}) {
    const missing = (() => {
        const stored = storage.get(STORAGE_KEYS.IDENTITY_MISSING);
        return Array.isArray(stored) && stored.length ? stored : ["phone"];
    })();
    const nextStep = storage.get(STORAGE_KEYS.IDENTITY_NEXT_STEP) || "paymentCards";
    const asksForNameOrEmail = missing.includes("name") || missing.includes("email");

    const done = () => {
        storage.remove(STORAGE_KEYS.IDENTITY_MISSING);
        storage.remove(STORAGE_KEYS.IDENTITY_NEXT_STEP);
        queryClient.invalidateQueries({queryKey: ['user', 'account']});
        setStep(nextStep);
    };

    return (
        <>
            <ModalHeader
                title="Complete your profile"
                extraClasses=""
                totalSteps={0}
                cancelButton={false}
                backStep="orderDetails"
                showBackButton={true}
                setStep={setStep}
                closeModal={closeModal}
            />

            <div className="modalPages-spacing complete-profile">
                {/* The form leads with its own "Continue with" heading while a name / email is
                    missing; the phone-only variant has none, so the context line stays for it. */}
                {!asksForNameOrEmail && <h4>Your profile is incomplete</h4>}
                <CompleteProfileForm missing={missing} onCompleted={done}/>
            </div>
        </>
    );
}

export default CompleteProfile;
